import * as React from 'react';
import { BondsBondSIssuerName1 } from '../../../../../../../../../../../../../../../../../../../../actor/api/Services/bonds';
import { LinkedBondsElementTitleContainer } from './components';

export const LinkedBondsElementTitle = () => (
  <LinkedBondsElementTitleContainer>
    <BondsBondSIssuerName1 withRedactedIcon />
  </LinkedBondsElementTitleContainer>
);
